import { render } from "./OrderStatusCreatePage.vue?vue&type=template&id=6889c049"
import script from "./OrderStatusCreatePage.vue?vue&type=script&lang=js"
export * from "./OrderStatusCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__